import { FETCH_START, refreshView } from "ra-core";
import { all, delay, put, race, take, takeLatest } from "redux-saga/effects";
import { CLAIMS_UPDATE_OVERWATCH } from "~/actions/claimsUpdateOverwatch";

export function* handleClaimsUpdate() {
  const { dataReload, timeout } = yield race({
    dataReload: take(FETCH_START),
    timeout: delay(350)
  })

  if (timeout) {
    // This means the current position of route is safe after permissions/claims update,
    // thus, user is not been forcibly redirect to other safe fallback routes.
    // But, whenever claims update happens, the overall routes structure trends to change,
    // previously cached data might have been lost; so refresh the view to retore them
    yield put(refreshView())
  }
  // pop up message to inform user about what happened
}

export default function* claimsUpdateOverwatchSaga() {
  yield all([
    takeLatest(CLAIMS_UPDATE_OVERWATCH, handleClaimsUpdate)
  ])
}
